module.exports = __webpack_public_path__ + "img/guang.5b931378.png";